(function () {
  'use strict';

  angular.module('eclipseApp.myAccount').directive('quickActions', QuickActions);

  function QuickActions() {
    return {
      restrict: 'E',
      scope: {
        selectedBan: '=',
        selectedCtn: '=',
        losEnabled: '=',
        lostDeviceStatus: '=',
        voiceMailIndicator: '='
      },
      templateUrl: 'modules/my-account/wireless/quick-actions/quick-actions.view.html',
      controller: 'quickActionsController',
      controllerAs: 'qaCtrl',
      bindToController: true
    };
  }

})();
